module.exports = __webpack_public_path__ + "img/Aground-large.0baff9b6.png";